import React from "react";
import styles from "./watchlistNews.module.css";
import PlaceholderImage from "~components/Placeholder";

const WATCHLIST_NEWS_PLACEHOLDER_COUNT = 10;

export const WatchlistNewsPlaceholder = () => {
  return (
    <div className={styles.watchlistNews}>
      <div className={styles.title}>Watchlist News</div>
      <div className={styles.placeholderContainer}>
        {[...Array(WATCHLIST_NEWS_PLACEHOLDER_COUNT)].map((_, index) => (
          <PlaceholderImage
            key={`WatchlistNewsPlaceholder-${index}`}
            className={styles.placeholderItem}
          />
        ))}
      </div>
    </div>
  );
};
